import React, {Component} from "react";
import {Tooltip} from "react-tippy";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {icon} from "../../../styles/Details";

export class ClipboardCopy extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.copyText = "Copy to Clipboard";
        this.copiedText = "Copied!";
        this.state = {
            copied: false,
            toolTipText: this.copyText
        }

    }

    onCopy = () => {
        this.setState({copied: true, toolTipText: this.copiedText});
        setTimeout(() => this.setState({copied: false, toolTipText: this.copyText}), 2000);
    };

    render() {
        return (
            <Tooltip title={this.state.toolTipText} arrow={true} distance={0} theme={"light"}>
                <CopyToClipboard
                    text={JSON.stringify(this.props.data, null, 2)}
                    onCopy={this.onCopy}
                >

                    <FontAwesomeIcon
                        key={this.state.copied}
                        icon={["far", "clipboard"]}
                        className={icon}
                        size={"2x"}
                    />
                </CopyToClipboard>
            </Tooltip>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/results/details/Clipboard.js